import { dcFactory } from 'dc';
import ChatBotComponent from './js/chat-bot.component';

dcFactory.register(ChatBotComponent);
